export default "__VITE_ASSET__CcXti$rr__"